import React from 'react';

import BankAccountsFilter from 'pages/company/BankFeedRoute/components/FilterToolbar/BankAccountsFilter';
import DateRangeFilter from 'pages/company/BankFeedRoute/components/FilterToolbar/DateRangeFilter';
import CurrencyFilter from 'pages/company/BankFeedRoute/components/FilterToolbar/shared/CurrencyFilter';
import SearchFilter from 'pages/company/BankFeedRoute/components/FilterToolbar/shared/SearchFilter';
import ToolbarShell from 'pages/company/BankFeedRoute/components/FilterToolbar/shared/ToolbarShell';

// Bank tab toolbar: multi-select account filter + shared currency / date-range / search.
const BankFilterToolbar: React.FC = () => (
  <ToolbarShell>
    <BankAccountsFilter />
    <CurrencyFilter />
    <DateRangeFilter />
    <SearchFilter />
  </ToolbarShell>
);

export default BankFilterToolbar;
